import { useCallback } from 'react'
import { toaster } from '@!/components/ui/toaster'

/**
 * エラートースト表示フック
 * @returns {Function} showError - エラー情報を受け取りトーストを表示する関数
 */
export const useErrorToast = () => {
  const showError = useCallback(({ title, errorMessage, duration = 5000 }) => {
    toaster.create({
      title,
      description: errorMessage,
      type: 'error',
      duration,
      closable: true,
    })
  }, [])

  return { showError }
}
